import { Modal } from 'antd';

import { USER_ERR_MESSAGES, } from '@bakbak/common';

export const loginRegisterAlert = () => {
  Modal.error({
    title: USER_ERR_MESSAGES.LOGIN_OR_REGISTER,
  });
}




// WEBPACK FOOTER //
// ./src/modules/shared/LoginRegisterAlert.tsx